import * as React from "react";
import { RouteProps, RouterChildContext } from "react-router";
import { authStore } from "../auth";

export class AppRedirect extends React.Component<
  RouteProps | RouterChildContext | React.ComponentProps<any>
> {
  constructor(props: any) {
    super(props);
    // console.log(this.props.match.params.app)
    if (this.props.match.params.app === 'university') {
      // window.location.replace(
      //   `http://localhost:3001/landing?sessionKey=${authStore.currentUser.SessionKey}`
      // );
    }
    else if (this.props.match.params.app === 'pharmacy') {
      // window.location.replace(
      //   `http://localhost:8080/landing?sessionKey=${authStore.currentUser.SessionKey}`
      // );
    }
  }

  public render() {
    const { match } = this.props;

    return <span>Hi! Later, this will redirect you to {match.params.app}</span>;
  }
}

export default AppRedirect;


// WEBPACK FOOTER //
// ./src/modules/apps/AppRedirect.tsx